import { z } from 'zod';
import { passwordSchema } from './password.schema';

export const changePasswordSchema = z
  .object({
    currentPassword: passwordSchema,
    newPassword: passwordSchema,
    confirmNewPassword: passwordSchema,
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: 'Passwörter stimmen nicht überein.',
    path: ['confirmNewPassword'],
  });

export const adminChangePasswordSchema = z.object({
  id: z.string(),
  newPassword: passwordSchema,
});
